import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import { I18nText, AvatarUpload } from '@welldev-group/react-comp-lib';
import IconButton from '@welldev-group/rcl-icon-button';
import Modal from '@welldev-group/rcl-modal';
import httpClient from '../../../shared/libraries/httpClient';
import routes from '../../../shared/routes';

const AvatarModal = props => {
  const [modalOpen, setModalOpen] = useState(false);

  const { userId } = props;

  const saveAvatar = async image => {
    const formData = new FormData();
    formData.append('avatar', image);

    const { data } = await httpClient.put(
      routes.users.update({
        id: userId,
      }),
      formData,
    );

    if (data.error === null) {
      setModalOpen(false);
      window.location.reload(false);
    }
  };

  const onAvatarSave = image => {
    const file = new File([image], image.name, { type: image.type });
    saveAvatar(file);
  };

  return (
    <>
      <div>
        <IconButton
          version="v2"
          isIconOnly={true}
          icon={<Icon name="cameraAlt" />}
          onClick={() => setModalOpen(true)}
          size="large"
        />
      </div>
      <Modal
        className="modal__wrapper modal__wrapper-small"
        isVisible={modalOpen}
        onOutsideClick={() => setModalOpen(false)}
      >
        <>
          <div className="modal__header">
            <Modal.Title>
              <I18nText id="settings.change_picture" />
            </Modal.Title>
            <div
              onClick={() => setModalOpen(false)}
              onKeyDown={() => setModalOpen(false)}
              role="presentation"
            >
              <Icon name="close" size="normal" />
            </div>
          </div>
          <Modal.Content>
            <div className="grid">
              <div className="col-12 col-bleed settings__avatar-modal">
                <AvatarUpload
                  onAvatarUpload={onAvatarSave}
                  onClose={() => setModalOpen(false)}
                />
              </div>
            </div>
          </Modal.Content>
        </>
      </Modal>
    </>
  );
};

AvatarModal.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default AvatarModal;
